'use client'

export type HgApplePodcastEmbedProps = {
  url: string
}

export const HgApplePodcastEmbed = ({url}: HgApplePodcastEmbedProps) => {
  const link = new URL(url)

  return (
    <iframe
      data-chromatic="ignore"
      allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
      frameBorder="0"
      height="175"
      width="100%"
      style={{overflow: 'hidden', borderRadius: '12px'}}
      sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
      src={`https://embed.podcasts.apple.com/us/podcast${link.pathname}?${link.searchParams.toString()}&theme=auto`}
    ></iframe>
  )
}
